
  import Vue from "vue";
  import Component from "vue-class-component";

  import EmployeeDetailsCardEmployments from "./EmployeeDetailsCardEmployments.vue";
  import EmployeeDetailsCardExport from "./EmployeeDetailsCardExport.vue";
  import EmployeeDetailsCardOperator from "./EmployeeDetailsCardOperator.vue";
  import EmployeeDetailsCardPersonal from "./EmployeeDetailsCardPersonal.vue";
  import EmployeeDetailsCardWages from "./EmployeeDetailsCardWages.vue";
  import FabButton from "@/components/FabButton.vue";
  import {Watch} from "vue-property-decorator";
  import EmployeeService, {toEmployee} from "@/service/EmployeeService";
  import {HeaderModule, HeaderMutations} from "@/store/modules/header";
  import {Mutation} from "vuex-class";
  import Employee from "@/model/Employee";
  import {MessageTypes} from "@/components/message-types";
  import {CompanyLocation} from "@/model/CompanyLocation";
  import eventBus from "@/eventbus";
  import EmployeeDetailsCardReactivationForm from "@/views/Employee/forms/EmployeeDetailsCardReactivationForm.vue";
  import EmployeeDetailsCardDeactivationForm from "@/views/Employee/forms/EmployeeDetailsCardDeactivationForm.vue";

  @Component({
    components: {
      EmployeeDetailsCardDeactivationForm,
      EmployeeDetailsCardReactivationForm,
      EmployeeDetailsCardEmployments,
      EmployeeDetailsCardExport,
      EmployeeDetailsCardOperator,
      EmployeeDetailsCardPersonal,
      EmployeeDetailsCardWages,
      FabButton
    }
  })
  export default class EmployeeDetails extends Vue {
    private employee: Employee = new Employee();
    private companyLocations: Array<CompanyLocation> | null = null;
    private speedDial = false;

    private snackbarTimeout = -1;

    @Mutation(HeaderMutations.SET_TITLE, {namespace: HeaderModule})
    private mutationTitle: any;

    get fullName() {
      if (this.employee.firstName && this.employee.lastName) {
        return this.employee.firstName + " " + this.employee.lastName;
      } else {
        return "";
      }
    }

    get employeeUuid(): string {
      return this.$route.params.employeeUuid;
    }

    get isEditable(): boolean {
      return !this.isInactive && this.isAuthorized("Employee_EditOther_Edit");
    }

    get isInactive(): boolean {
      return this.employee && this.employee.active !== undefined && !this.employee.active;
    }

    @Watch("fullName")
    onFullNameChanged(value: string) {
      this.mutationTitle(value);
    }

    mounted() {
      this.load();
    }

    load() {
      if (this.employeeUuid) {
        EmployeeService.getEmployeeV3(this.employeeUuid, "FULL")
          .then(response => {
            this.employee = toEmployee(response.data);
          });
      }
    }

    update(updatedEmployee: Employee) {
      this.employee = Object.assign(new Employee(), updatedEmployee);
    }

    // used an object for state for readability
    handle_deactivated(state: {activationState: boolean}) {
      if(state.activationState) {
        this.employee.active = state.activationState;
      }
      this.load();
    }

    recreateWelcomePdf() {
      if (this.employee.uuid) {
        EmployeeService.createWelcomePdf(this.employee.uuid)
          .then(welcomeDocument => {
            const url = window.URL.createObjectURL(welcomeDocument.content);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", welcomeDocument.filename);
            document.body.appendChild(link);
            link.click();
          });
      }
    }

    showDeactivationForm() {
      if(this.employee.uuid && this.employee.active) {
        this.showForm(MessageTypes.OPEN_EMPLOYEE_DEACTIVATE);
      }
    }

    showReactivationForm() {
      if (this.employee.uuid && !this.employee.active) {
        this.showForm(MessageTypes.OPEN_EMPLOYEE_REACTIVATE);
      }
    }
    showForm(messageType:string) {
      const firstName = this.employee.firstName ?? "";
      const lastName = this.employee.lastName ?? "";
      eventBus.$emit(messageType, {uuid: this.employee.uuid, firstName, lastName});

    }
  }
